import styles from "./index.css";
import content from "app-content";
import PropTypes from "prop-types";
import formatPrice from "../formatPrice";

const LastBestPrice = ({
  lowestPriceInLast30DaysValue,
  lowestPriceInLast30DaysPercentage,
  currentPrice
}) => {
  const sign = ["-", "", "+"][
    Math.sign(currentPrice - lowestPriceInLast30DaysValue) + 1
  ];
  const value = Math.abs(lowestPriceInLast30DaysPercentage);

  return (
    <div className={styles.lastBestPrice}>
      <span>{content.lowest_price_last_thirty_days}</span>
      <span>{formatPrice(lowestPriceInLast30DaysValue)}</span>
      <span
        className={sign === "-" ? styles.discounted : null}
      >{`(${sign}${value}%)`}</span>
    </div>
  );
};

LastBestPrice.propTypes = {
  lowestPriceInLast30DaysValue: PropTypes.number,
  lowestPriceInLast30DaysPercentage: PropTypes.number,
  currentPrice: PropTypes.number
};

export default LastBestPrice;
